module.exports = __webpack_public_path__ + "static/media/team-3.39f0dbfe.webp";